import PortfolioView from './PortfolioView'

export default PortfolioView
